module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NKlgrG/tc-custom/9781685507923.jpg?1723403959354",
      "alt": "This image is the cover for the book 14 Beats—No Breath"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("14 Beats—No Breath\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Cecil, son of Anna and Dr. Albert Morgan, was raised in a well-to-do neighborhood in the 1930s. Always feeling different -- separate -- from everyone around him, after college, he relocates to an Appalachian Mountain cabin."), _c('br'), _c('br'), _vm._v("Lonely at first, Cecil spends a great deal of time talking to himself. One night, he hears a song on a breeze with a long note held for fourteen beats. As far as Cecil knows, he is alone on that side of the desolate mountain, so who is singing?"), _c('br'), _c('br'), _vm._v("He eventually meets up with the mysterious mountain man without a name, a man who also lives separated from the world. Was his seclusion a choice? When illness occurs, will the aid Cecil brings during a time when doctors treat mental illness like a crime and homosexuality as a mental illness make things better or worse?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Connor, E.F. Mulder\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0